export const createRecoilKey = (suffix: string) => {
  return `ui-merchant-cabinet.${suffix}`;
};
